import AuthService from './AuthService';

const authService = new AuthService();

// eslint-disable-next-line import/no-default-export
export default authService;
